import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { utility } from '../utility/utility';
import { LOCAL_STORAGE_KEY } from '../constant';
import { getAllProfiles, getOttSettings } from '../Api/api';

export const fetchInitialData = createAsyncThunk(
    'application/fetchInitialData',
    async () => {
        try {
            let initialData = {
                profiles: null,
                logo: null,
                theme: null,
                ottSettings: null,
            }
            let user = utility.getValue(LOCAL_STORAGE_KEY.user) ?? null;
            if (user) {
                const response = await getAllProfiles(user._id)
                if (response.success) {
                    initialData.profiles = response?.data ?? [];
                }
            }
            const ottSettingRes = await getOttSettings();
            if (ottSettingRes.success) {
                initialData.ottSettings = { ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting };
                initialData.theme = ottSettingRes.data.themeData;
                initialData.logo = ottSettingRes.data.logo;
            }
            return initialData;
        } catch (error) {
            console.log("error", error.message);
            throw error;
        }
    }
);

const prepareProfiles = (profiles) => {
    if (!Array.isArray(profiles)) return [];
    let updateProfiles = [...profiles];
    if (updateProfiles?.length != 0 && updateProfiles?.length < 5) {
        updateProfiles.push({
            addNew: true,
            SubscriberId: updateProfiles[0].SubscriberId,
            Description: "",
            ContinueWatching: [],
            EnablePgRestriction: false,
            Restricted_PgRatings: [],
            EnableParentalControl: false,
            Pin: "0000",
            AutoplayNextEpisode: false,
            Avatar: 0,
        });
    }
    return updateProfiles;
}

const applicationSlice = createSlice({
    name: 'application',
    initialState: {
        user: utility.getValue(LOCAL_STORAGE_KEY.user) ?? null,
        logo: null,
        theme: null,
        profiles: [],
        selectedProfile: null,
        editedProfile: null,
        ottSettings: null,
        applicationLoading: false,
        applicationError: null,
        dialog: {
            show: false,
            message: "",
            showCanclButton: false,
            cancelText: "Cancel",
            confirmText: "Ok",
            onConfirm: () => { },
            onCancel: () => { },
        }
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setPrevPath: (state, action) => {
            state.prevPath = action.payload;
        },
        setLogo: (state, action) => {
            state.logo = action.payload;
        },
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        setProfiles: (state, action) => {
            state.profiles = prepareProfiles(action.payload);
        },
        setSelectedProfile: (state, action) => {
            state.selectedProfile = action.payload;
            state.editedProfile = action.payload;
        },
        setEditedProfile: (state, action) => {
            state.editedProfile = action.payload;
        },
        setOttSettings: (state, action) => {
            state.ottSettings = action.payload;
        },
        showDialog: (state, action) => {
            let payload = {
                show: true,
                message: action.payload?.message ?? "No message",
                showCanclButton: action.payload?.showCanclButton ?? false,
                cancelText: action.payload?.cancelText ?? "Cancel",
                confirmText: action.payload?.confirmText ?? "Ok",
                onCancel: action.payload?.onCancel ?? (() => { }),
                onConfirm: action.payload?.onConfirm ?? (() => { }),
            }
            state.dialog = payload;
        },
        closeDialog: (state) => {
            let payload = {
                show: false,
                message: "",
                showCanclButton: false,
                cancelText: "Cancel",
                confirmText: "Ok",
                onCancel: () => { },
                onConfirm: () => { },
            }
            state.dialog = payload;
        },
        resetApplication: (state) => {
            state.selectedProfile = null;
            state.user = null;
            state.prevPath = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInitialData.pending, (state) => {
                state.applicationLoading = true;
                state.applicationError = null;
            })
            .addCase(fetchInitialData.fulfilled, (state, action) => {
                state.applicationLoading = false;
                state.applicationError = null;
                state.logo = action.payload.logo;
                state.theme = action.payload.theme;
                state.ottSettings = action.payload.ottSettings;
                state.profiles = prepareProfiles(action.payload.profiles);
            })
            .addCase(fetchInitialData.rejected, (state, action) => {
                state.applicationLoading = false;
                state.applicationError = action.error.message;
            })
    },
});

export const { setUser, setPrevPath, setLogo, setTheme, setProfiles, setSelectedProfile, setOttSettings, setEditedProfile, showDialog, closeDialog, resetApplication } = applicationSlice.actions;
export default applicationSlice.reducer;